<template>
  <div class="overflow-y-scroll flex grow items-center flex-row">
    <div
      v-if="!fundraiserStore.saveError"
      class="flex grow items-center flex-col"
      data-test="success-message"
    >
      <div class="sub-header !mb-8">{{ fundraiserStore.editFundraiser ? 'Updating' : 'Creating' }} your fundraiser</div>
      <div
        class="loader block !h-2 !w-2"
        data-test="loader"
      ></div>
    </div>
    <div
      v-else
      class="flex grow items-center flex-col"
      data-test="error-message"
    >
      <div class="sub-header !mb-8">An error occurred while saving your fundraiser.</div>
      <p>Please go back and try again.</p>
    </div>
  </div>
</template>

<script setup>
import { useFundraiserStore } from '@/stores/FundraiserStore.js';
const fundraiserStore = useFundraiserStore();
</script>
